import React, { useEffect, useState } from 'react';
import Table from '../Table/Table';
import { tableHeadings } from '../../../utils/constants';
import { fetchTerminalBatchData } from '../../../redux/actions/TerminalActions';
import { connect } from "react-redux";
import { Panel, PanelHeader } from '../../header/panel/panel';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

const TerminalBatchList = (props) => {

    const [infoModelOpen, setInfoModelOpen] = useState(false);


    useEffect(() => {
        props.fetchTerminalBatchData(props.terminalID)

    }, [props.TERMINALREDUCER.loadingBatchData])


    const INFO_DATA = (
        <div>
            <Modal isOpen={infoModelOpen} toggle={() => setInfoModelOpen(!infoModelOpen)}>
                <ModalHeader toggle={() => setInfoModelOpen(!infoModelOpen)} close={<button className="btn-close" onClick={() => setInfoModelOpen(!infoModelOpen)}></button>}>Terminal batch list information</ModalHeader>
                <ModalBody>

                    <p>
                        This list is just for reference to show batch data sent back upon request from terminal.
                        If you see multiple records for same day, it implies terminal requested for batch multiple times on that day.
                    </p>
                    <p>
                        <b>Note:</b> Counts are reset after the end of each day.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-white" onClick={() => setInfoModelOpen(false)}>Close</button>
                </ModalFooter>
            </Modal>
        </div>
    )

    return (

        <Panel>

            <PanelHeader>
                <div className="row mb-0">

                    <div className="col-xl-11">
                        TERMINAL BATCH
                    </div>
                    <div className="col-xl-1">
                        <div className="align-item-left"> <i className="icon-info h5 d-block" onClick={() => setInfoModelOpen(true)}></i>
                            {INFO_DATA}
                        </div>
                    </div>
                </div>
            </PanelHeader>

            {!props.TERMINALREDUCER.loadingBatchData ? <Table height={600} headings={tableHeadings.terminalBatchTotals} data={props.TERMINALREDUCER.terminalBatchData} /> : null}

        </Panel>


    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchTerminalBatchData,
}


export default connect(mapStateToProps, mapDispatchToProps)(TerminalBatchList);